export enum MonitorMainTabsEnum {
  MyClasses = 1,
  AllLessons = 2
}
